import React from 'react'

const ProfileSectionEmployCriteria = ({ section }) => {
  if (!section.additional) {
    return null
  }

  return (
    <ul style={{ padding: 0 }} className="selections">
      {section.additional
        .sort((x, y) => (x.selected === y.selected ? 0 : x.selected ? -1 : 1))
        .map(a => (
          <li
            className={a.selected ? 'yup' : 'nope'}
            key={a.value}
            style={{ listStyleType: 'none', margin: 0 }}>
            <i
              style={{ marginRight: '0.5em', color: a.selected ? 'green' : 'red' }}
              className={`fal ${a.selected ? 'fa-check' : 'fa-times'}`}>
            </i>
            <span>{a.value}</span>
          </li>
        ))}
    </ul>
  )
}

export default ProfileSectionEmployCriteria
